<template>
  <input data-type="phone" type="text" v-model="content" @keyup="formatPhone"/>
</template>

<script>
  export default {
    props: ['value'],
    data () {
      return {
        content: this.value
      };
    },
    mounted () {
      var id = uniqid();
      $(this.$el).attr('id', id);
      var parent = $(this.$el).parent();
      parent.prev().attr('for', id);
      parent.next().attr('id', id+'-message');
      this.formatPhone();
    },
    watch: {
      content(n, o) {
        this.$emit('input', n);
      },
      value(val) {
        this.content = this.value;
        this.$nextTick(function() {
          this.formatPhone({ keyCode: '' });
        });
      }
    },
    methods: {
      insertAt (str, start, delCount, newSubStr) {
        return str.slice(0, start) + newSubStr + str.slice(start + Math.abs(delCount));
      },
      formatPhone (e) {
        var $this = $(this.$el);
        var old = $this.data('old');
        var val = $this.val();

        if (typeof e !== 'undefined') {
          if (e.code==null) return;
          let num = e.code.replace(/[^0-9\.]/g, '');
          const validValue = val.replace(/[^0-9\.]/g, '');
          if ((!/\d/.test(num) && val!='' && e.code.toLowerCase() != 'backspace' && !/\d/.test(validValue)) || val.length > 14) {
            $this.val(old);
            return;
          }
        }

        if (typeof old == 'undefined') {
          old = '';
        }

        if (!val.replace(/\D/g, '').length) {
          return;
        }

        let formatted = '(' + val.replace(/\D/g, '');

        if (formatted.length > 4) {
          formatted = this.insertAt(formatted, 4, 0, ') ');
        }

        if (formatted.length > 9) {
          formatted = this.insertAt(formatted, 9, 0, '-');
        }

        $this.val(formatted);
        this.$emit('input', formatted);
        $this.data('old', formatted);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/phone.vue